import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { ISessionsState } from './state';

const defaultState: ISessionsState = {
  sessions: [],
};

export const SessionModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
